import React from 'react';
import styled from 'styled-components';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Button, ButtonStyleType } from '@barpay/barpay-design-system';
import { Typography } from '@barpay/barpay-design-system';
import { colors } from '@barpay/barpay-design-system';
import { useDispatch } from 'react-redux';
import { clearPaymentError } from 'store/actions';
const { H2, H5 } = Typography;
const PageContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${colors.background};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

const Header = styled.header`
  margin-top: 2rem;
  text-align: center;
`;

const Main = styled.main`
  text-align: center;
  width: 80%;
`;
const Footer = styled.footer`
  width: 80%;
  margin-bottom: 2rem;
`;

function FastPassError() {
  const history = useHistory();
  const dispatch = useDispatch();
  let { id } = useParams();
  let queryParams = new URLSearchParams(useLocation().search);
  let error = queryParams.get('error');

  const errorMessage = !error
    ? 'An error has occurred while ordering your fast pass. Please try again, and if the error persists please contact the venue for further instructions.'
    : error;
  return (
    <PageContainer>
      <Header></Header>
      <Main>
        <H2>IMPORTANT PLEASE READ!</H2>
        <H5 fontWeight={400}>{errorMessage}</H5>
      </Main>
      <Footer>
        <Button
          onClick={() => {
            dispatch(clearPaymentError());
            if (error === 'The qrcode scanned is not valid') {
              history.goBack();
            } else {
              history.push(`/venue/${id}/fastpass`);
            }
          }}
          label="Go Back"
          styleType={ButtonStyleType.Primary}
        />
      </Footer>
    </PageContainer>
  );
}

export default FastPassError;
